import type { CourseFilters } from "~/business-areas/course/composables/course-list.hook";

export type CatalogInterFiltersSchema = Pick<
  CourseFilters,
  "tags" | "duration" | "from" | "to"
>;

export function useCatalogInterFilters() {
  return useUrlFilters({
    tags: {
      default: [] as string[],
      transform(value) {
        if (value === undefined || value === "") return [];

        return toArray(value as string);
      },
    },
    duration: { default: undefined as unknown as string },
    from: { default: undefined as unknown as string },
    to: { default: undefined as unknown as string },
    inter: { default: true },
  });
}
